import { render, staticRenderFns } from "./FilterBarContentTypeItemSeo.vue?vue&type=template&id=3b55ae6c"
import script from "./FilterBarContentTypeItemSeo.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterBarContentTypeItemSeo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilterBarContentTypeItemSeo.vue?vue&type=style&index=0&id=3b55ae6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports